var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.83594 15.5C2.3776 15.5 1.98524 15.3368 1.65885 15.0104C1.33247 14.684 1.16927 14.2917 1.16927 13.8333V3H0.335938V1.33333H4.5026V0.5H9.5026V1.33333H13.6693V3H12.8359V13.8333C12.8359 14.2917 12.6727 14.684 12.3464 15.0104C12.02 15.3368 11.6276 15.5 11.1693 15.5H2.83594ZM11.1693 3H2.83594V13.8333H11.1693V3ZM4.5026 12.1667H6.16927V4.66667H4.5026V12.1667ZM7.83594 12.1667H9.5026V4.66667H7.83594V12.1667Z",
    fill: "#DB545D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteicon);
export default __webpack_public_path__ + "static/media/deleteicon.d79099782967d96af18af26263f7109a.svg";
export { ForwardRef as ReactComponent };